import React from "react";
import { Accordion, AccordionContent } from "../../../../components/accordion";
import { t } from "../../../../core/translate";
import { StyledAccordionButton, StyledCaret, ThemedList } from "./styles";
import { AppsIcon } from "./styles";
import {
  vstStore,
  bookshelf,
  vstAnalytics,
  readOffline,
  brandSpecificApps
} from "../menu-items/apps";

export default ({ headingLevel }) => {
  const data = [
    {
      listItems: [vstStore(), bookshelf(), vstAnalytics(), readOffline()]
        .concat(brandSpecificApps())
        .filter(el => !!el)
    }
  ];
  return (
    <Accordion>
      <StyledAccordionButton level={headingLevel}>
        <AppsIcon color="white" smallMargin viewBox="0 -6 33 33" />
        {t("global-bar.app", "App")}
        <StyledCaret />
      </StyledAccordionButton>
      <AccordionContent>
        <ThemedList data={data} />
      </AccordionContent>
    </Accordion>
  );
};
